"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
/* eslint-disable */
__exportStar(require("./AssortmentApi"), exports);
__exportStar(require("./AttestationApi"), exports);
__exportStar(require("./CartApi"), exports);
__exportStar(require("./CustomerApi"), exports);
__exportStar(require("./OidcConfigurationApi"), exports);
__exportStar(require("./OrderApi"), exports);
__exportStar(require("./ShopApi"), exports);
__exportStar(require("./ShopUserApi"), exports);
__exportStar(require("./StripeApi"), exports);
__exportStar(require("./UserApi"), exports);
